import { useDemoMode } from '@/hooks/useDemoMode';

/**
 * Synlig demo-markering. Vises som slank banner under headeren når den
 * indloggede profils afdeling hører til demo-kommunen.
 */
export function DemoBadge() {
  const { isDemo } = useDemoMode();

  if (!isDemo) return null;

  return (
    <div
      role="status"
      data-testid="demo-badge"
      className="w-full bg-app-warning-bg border-b border-app-warning/40 px-4 py-1.5 text-center"
    >
      <span className="text-xs font-semibold uppercase tracking-wider text-app-warning-text">
        Demo
      </span>
      <span className="ml-2 text-xs text-app-warning-text">
        Du ser testdata — ingen rigtige borgere eller vagter
      </span>
    </div>
  );
}
